import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { uploadPDF, PDFTemplate } from '../api/client';

interface PDFUploadProps {
  onUploadSuccess: (template: PDFTemplate) => void;
}

const PDFUpload: React.FC<PDFUploadProps> = ({ onUploadSuccess }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onDrop = async (acceptedFiles: File[]) => {
    if (acceptedFiles.length === 0) return;

    const file = acceptedFiles[0];
    if (file.type !== 'application/pdf') {
      setError('Please upload a PDF file');
      return;
    }

    setUploading(true);
    setError(null);

    try {
      const template = await uploadPDF(file);
      onUploadSuccess(template);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to upload PDF');
    } finally {
      setUploading(false);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
    },
    multiple: false,
  });

  return (
    <div className="pdf-upload">
      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? 'active' : ''} ${uploading ? 'uploading' : ''}`}
      >
        <input {...getInputProps()} />
        {uploading ? (
          <p>Uploading and analyzing PDF...</p>
        ) : isDragActive ? (
          <p>Drop the PDF here...</p>
        ) : (
          <p>Drag & drop a PDF file here, or click to select</p>
        )}
      </div>
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default PDFUpload;
